import { render, staticRenderFns } from "./CreateLastContact.vue?vue&type=template&id=ebb70b52&"
import script from "./CreateLastContact.vue?vue&type=script&lang=js&"
export * from "./CreateLastContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports